export default __webpack_public_path__ + "static/media/reactjs.1520bd67.svg";